import styled from 'styled-components';

export const StyledChristmasIcon = styled.img`
  height: 2.5rem;
  width: 2.5rem;
`;
